<template>
  <div id="chart-editor-container">
    <JSpreadsheet @updateData="updateChartData" />
  </div>
</template>

<script setup lang="ts">
import JSpreadsheet from "@/views/components/element/JSpreadsheet.vue"
import {useWidgetStore, useMainStore} from "@/store";
import {storeToRefs} from "pinia";
import {onMounted, onUnmounted} from "vue";

const widgetStore = useWidgetStore()
const { selectedWidget } = storeToRefs(widgetStore)

const mainStore = useMainStore()

onMounted(() => {
  mainStore.setDisableHotkeysState(true)
})

onUnmounted(() => {
  mainStore.setDisableHotkeysState(false)
})

const updateChartData = (newData: any) => {
  if (selectedWidget.value.type !== 'chart') return
  selectedWidget.value.data.series = newData
}
</script>

<style scoped lang="scss">
#chart-editor-container {
  width: 600px;
  position: relative;
}

</style>